export default __webpack_public_path__ + "static/media/picking_apples.svg";